<script setup>
import { ref, computed } from 'vue'
import _ from 'lodash';
import { useNotification } from "@kyvg/vue3-notification";
import moment from 'moment-timezone';
import MediaflowService from '@/services/MediaflowService';
import AddPlayoutErrorAlert from '@/components/TVPlayout/AddPlayoutErrorAlert.vue'
import { useStore } from 'vuex'
import FormButton from '../Atoms/FormButton.vue'
import FloatingInput from '../ui/FloatingInput.vue'
import Sidebar from '../modals/Sidebar'

const store = useStore()
const { notify } = useNotification()

const sidebar = ref()
const error = ref(null)

const mediaflow = ref({
	name: '',
})
const selectedStream = ref(null)

const emit = defineEmits(['mediaflow-added'])

const toggleSidebar = () => sidebar.value.toggleSidebar()

const onReset = (() => {
	mediaflow.value = { name: '' }
	error.value = null
	selectedStream.value = null
})

const createMediaflow = (async () => {
	try {
		store.dispatch('Ui/setLoadingStatus', true)
		const newPayout = await MediaflowService.createMediaflow(
			mediaflow.value.name,
			selectedStream.value?._id ?? null
		);
		emit('mediaflow-added', newPayout)
		notify({ group: 'success', text: 'Cloud production created.' })
		sidebar.value.closeSidebar()
		store.dispatch('Ui/setLoadingStatus', false)
	} catch (err) {
		console.log(err);
		error.value = err.message
		store.dispatch('Ui/setLoadingStatus', false)
	}
})

defineExpose({ toggleSidebar })
</script>

<template>
	<Sidebar ref="sidebar" :stage="1" @closed="onReset" width="md:w-[420px]">
		<template v-slot:stage-one>
			<div class="px-4 h-full">
				<h3 class="text-lg font-medium mb-2 mt-3">New Cloud Production</h3>
				<p class="text-dark-7 mb-4 text-sm"></p>
				<AddPlayoutErrorAlert :error="error" v-if="error" />
				<div class="mb-3">
					<FloatingInput id="mediaflow-name" label="Cloud Production name" surface="2" dense v-model="mediaflow.name" />
				</div>
				<div class="text-center">
					<FormButton :disabled="mediaflow.name.length === 0" @click="createMediaflow" type="primary" size="md"
						class="w-full mt-2 justify-center">
						Create
					</FormButton>
					<FormButton type="secondary" size="md" class="w-full mb-3 mt-2 justify-center"
						@click="toggleSidebar">
						Cancel
					</FormButton>
				</div>
			</div>
		</template>
	</Sidebar>
</template>
